import { Plus } from 'lucide-react';
import { Button, Input } from '@platform/design-system';
import type { KeyboardEvent } from 'react';
import styles from './ProductEditor.module.css';

const MAX_OPTION_NAME_LENGTH = 60;

export type InlineCreateProps = {
  label: string;
  actionLabel: string;
  value: string;
  pending: boolean;
  onChange: (value: string) => void;
  onCreate: (name: string) => void;
};

export const InlineCreate = ({
  label,
  actionLabel,
  value,
  pending,
  onChange,
  onCreate,
}: InlineCreateProps) => {
  const ready = value.trim() !== '' && !pending;
  const create = () => {
    if (ready) onCreate(value.trim());
  };
  const createOnEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    create();
  };

  return (
    <div className={styles['inlineCreate']}>
      <Input
        label={label}
        maxLength={MAX_OPTION_NAME_LENGTH}
        value={value}
        enterKeyHint="done"
        onChange={(event) => {
          onChange(event.target.value);
        }}
        onKeyDown={createOnEnter}
      />
      <Button
        icon={<Plus size={20} aria-hidden="true" />}
        variant="outline"
        disabled={!ready}
        onClick={create}
      >
        {actionLabel}
      </Button>
    </div>
  );
};
